import {Injectable} from '@angular/core';
import {TopLink} from "./skeleton/types/top-link";

@Injectable()
export class VariablesService {

    constructor() {
    }

    public apiURI = "http://api.mirabase.ru/api";

    public getPreviewImageUrl(w,h,url){
        return `http://base.mirabase.ru/mirabasefile/${url}`;
    }

    public activeBases = [
            {link:'/nb', image:'/assets/skeleton/img/base.svg', name: 'Базаз Жилых комплексов'},
            {link:'/ob', image:'/assets/skeleton/img/base.svg', name: 'Базаз Вторичной недвижимости'},
            {link:'/zem', image:'/assets/skeleton/img/base.svg', name: 'Базаз Земельных участков'},
        ];

    public topSkeletonLinks: TopLink[]=[];

    public httpConfig = {withCredentials: true};

    public sityId=1;

    public api(uri){
        return `${this.apiURI}/${uri}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/variables.service.ts